import { ActionIcon } from '@mantine/core';
import type { CustomPropertyOut } from '@repo/api-codegen';
import { Icon } from '@repo/foundations';
import type { CatalogProperty } from '../../api';
import { openModal } from '../ModalManager';
import { TagOptionsModal } from './TagOptionsModal';

export type CustomPropertyCatalogProperty = CatalogProperty &
	CustomPropertyOut & {
		entity_types: string[];
	};

interface TagOptionsButtonProps {
	property: CustomPropertyCatalogProperty | undefined;
	customPropertyId: string | undefined;
}

export function TagOptionsButton({
	property,
	customPropertyId,
}: TagOptionsButtonProps) {
	if (!property) {
		return null;
	}

	if (property.value_type !== 'select') {
		return null;
	}

	const handleClick = () => {
		openModal({
			title: 'Manage options',
			children: (
				<TagOptionsModal
					customPropertyId={customPropertyId}
					propertyLabel={property.value}
				/>
			),
		});
	};

	return (
		<ActionIcon onClick={handleClick} size="xs">
			<Icon name="tag" />
		</ActionIcon>
	);
}
